import { z } from "zod";

/**
 * Complete an MCP server OAuth flow - Request body.
 *
 * The authorization server's redirect, forwarded VERBATIM: the backend callback
 * hands it to the frontend in the consenting browser, and the frontend sends it here
 * under its own sign-in. RFC 6749 §4.1.2 (`code`, `state`, `scope`), §4.1.2.1
 * (`error`) and RFC 9207 (`iss`).
 *
 * Only `state` is required. Which combination is legal is the use case's decision —
 * an `error` response is still subject to the `iss` check, and one with neither
 * `code` nor `error` is refused after the flow is consumed, so the attempt is
 * recorded rather than left to expire.
 */
export const CompleteMcpServerOAuthBodySchema = z.strictObject({
  state: z.uuid(),
  code: z.string().min(1).optional(),
  error: z.string().min(1).optional(),
  iss: z.string().min(1).optional(),
  scope: z.string().optional()
});

export type CompleteMcpServerOAuthBody = z.infer<typeof CompleteMcpServerOAuthBodySchema>;

/** Complete an MCP server OAuth flow - the server that is now connected. */
export const CompleteMcpServerOAuthResponseSchema = z.object({
  externalToolId: z.string().uuid(),
  handshakeId: z.string().uuid()
});
